<template>
  <base-container :isLoading="loading">
    <artisan-group title="查询">
      <div style="padding: 10px 50px">
        <span>日期范围：</span>
        <el-date-picker
          v-model="daterange"
          type="daterange"
          align="right"
          size="mini"
          :clearable="false"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button
          class="margin-h12"
          type="primary"
          size="mini"
          icon="el-icon-search"
          @click="loadData()"
          >查询</el-button
        >
      </div>
      <div style="padding: 10px 50px">
        <span>执行科室：</span>
        <el-select size="mini" v-model="deptId">
          <el-option
            v-for="dept in deptList"
            :key="dept.id"
            :value="dept.id"
            :label="dept.name"
          >
          </el-option>
        </el-select>
      </div>
    </artisan-group>
    <div style="padding: 10px 20px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-card>
            <el-row
              slot="header"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <b class="color-primary">
                门诊开单量：{{ totalMap.outpatient.total }}
              </b>
              <b class="color-primary">
                门诊预约量：{{ totalMap.outpatient.success }}
              </b>
              <b class="color-success">
                门诊预约率：{{ totalMap.outpatient.rate }}%
              </b>
            </el-row>
            <el-row type="flex" justify="space-between" align="middle">
              <div
                class="padding5 align-center"
                v-for="(label, status) in statusMap"
                :key="status"
                :class="statusClassMap[status]"
              >
                <div>{{ label }}</div>
                <b class="text-large">{{ totalMap.outpatient[status] }}</b>
              </div>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card>
            <el-row
              slot="header"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <b class="color-primary"
                >住院开单量：{{ totalMap.inpatient.total }}
              </b>
              <b class="color-primary">
                住院预约量：{{ totalMap.inpatient.success }}
              </b>
              <b class="color-success"
                >住院预约率：{{ totalMap.inpatient.rate }}%
              </b>
            </el-row>
            <el-row type="flex" justify="space-between" align="middle">
              <div
                class="padding5 align-center"
                v-for="(label, status) in statusMap"
                :key="status"
                :class="statusClassMap[status]"
              >
                <div>{{ label }}</div>
                <b class="text-large">{{ totalMap.inpatient[status] }}</b>
              </div>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div id="exeDeptTrend" style="height: 500px"></div>
  </base-container>
</template>

<script>
import { getAuthDepts } from "@/api/jc/dept";
import { getExeDeptSummary, getExeDeptTrend } from "@/api/jc/summary";
import * as echarts from "echarts";
import moment from "moment";
export default {
  data() {
    let end = moment().format("yyyy-MM-DD");
    let start = moment().subtract(7, "days").format("yyyy-MM-DD");
    return {
      loading: false,
      deptId: "",
      daterange: [start, end],
      deptList: [],
      totals: [],
      totalTrend: [],
      statusMap: {
        wait: "待预约",
        ok: "已预约",
        sign: "已签到",
        check: "已检查",
        report: "出报告",
        cancel: "已取消",
        scrap: "已作废",
      },
      statusClassMap: {
        wait: "color-info",
        ok: "color-success",
        sign: "color-success",
        check: "color-success",
        report: "color-success",
        cancel: "color-warning",
        scrap: "color-danger",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      chartOption: {
        title: {
          text: "开单趋势",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["门诊", "住院"],
          left: "right",
        },
        color: ["#F56C6C", "#4995f9"],
        grid: {
          left: "1%",
          right: "1%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [],
      },
    };
  },
  computed: {
    totalMap() {
      let map = {
        inpatient: {
          total: 0,
          success: 0,
          rate: 0,
          wait: 0,
          ok: 0,
          sign: 0,
          check: 0,
          report: 0,
          cancel: 0,
          scrap: 0,
        },
        outpatient: {
          total: 0,
          success: 0,
          rate: 0,
          wait: 0,
          ok: 0,
          sign: 0,
          check: 0,
          report: 0,
          cancel: 0,
          scrap: 0,
        },
      };
      this.totals.forEach((c) => {
        if (c.exeDeptId == this.deptId) {
          if (c.clinicType == "inpatient") {
            map.inpatient.total += c.count;
            map.inpatient[c.status] = c.count;
            if (
              c.status == "ok" ||
              c.status == "sign" ||
              c.status == "check" ||
              c.status == "report"
            ) {
              map.inpatient.success += c.count;
            }
          } else if (c.clinicType == "outpatient") {
            map.outpatient.total += c.count;
            map.outpatient[c.status] = c.count;
            if (
              c.status == "ok" ||
              c.status == "sign" ||
              c.status == "check" ||
              c.status == "report"
            ) {
              map.outpatient.success += c.count;
            }
          }
        }
      });
      if (map.inpatient.total > 0) {
        map.inpatient.rate = parseInt(
          (map.inpatient.success * 100) / map.inpatient.total
        );
      }
      if (map.outpatient.total > 0) {
        map.outpatient.rate = parseInt(
          (map.outpatient.success * 100) / map.outpatient.total
        );
      }
      return map;
    },
  },
  created() {
    this.loading = true;
    getAuthDepts()
      .then((res) => {
        this.deptList = res.data.data;
        this.deptId = this.deptList[0].id;
        return getExeDeptSummary(this.daterange[0], this.daterange[1]);
      })
      .then((res) => {
        this.totals = res.data.data;
        this.loading = false;
        return getExeDeptTrend(
          this.daterange[0],
          this.daterange[1],
          this.deptId
        );
      })
      .then((res) => {
        this.totalTrend = res.data.data;
        this.$nextTick(() => {
          this.buildTrend();
        });
      })
      .catch(() => {
        this.loading = false;
      });
  },
  methods: {
    loadData() {
      getExeDeptSummary(this.daterange[0], this.daterange[1]).then((res) => {
        this.totals = res.data.data;
      });
      this.loading = true;
      getExeDeptTrend(this.daterange[0], this.daterange[1], this.deptId)
        .then((res) => {
          this.loading = false;
          this.totalTrend = res.data.data;
          this.buildTrend();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    buildTrend() {
      let myChart = echarts.init(document.getElementById("exeDeptTrend"));
      let xAxis = [];
      let outData = [];
      let inData = [];
      const dataArr = this.getTrendArr();
      dataArr.forEach((c) => {
        xAxis.push(c.billDate);
        outData.push(c.outData);
        inData.push(c.inData);
      });
      this.chartOption.xAxis.data = xAxis;
      this.chartOption.series = [];
      this.chartOption.series.push({
        name: "门诊",
        type: "line",
        stack: "总量",
        smooth: true,
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        areaStyle: {},
        emphasis: {
          focus: "series",
        },
        data: outData,
      });
      this.chartOption.series.push({
        name: "住院",
        type: "line",
        stack: "总量",
        smooth: true,
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        areaStyle: {},
        emphasis: {
          focus: "series",
        },
        data: inData,
      });
      myChart.setOption(this.chartOption);

      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    getTrendArr() {
      let trendMap = {};
      this.totalTrend.forEach((item) => {
        let trend = trendMap[item.billDate] || {
          billDate: item.billDate,
          outData: 0,
          inData: 0,
        };
        if (item.clinicType == "outpatient") {
          trend.outData += item.count;
        } else if (item.clinicType == "inpatient") {
          trend.inData += item.count;
        }
        trendMap[item.billDate] = trend;
      });
      let start = moment(this.daterange[0]);
      let end = moment(this.daterange[1]);
      let arr = [];
      do {
        const s = start.format("YYYY-MM-DD");
        let trend = trendMap[s];
        if (trend) arr.push(trend);
        else arr.push({ billDate: s, outData: 0, inData: 0 });
        start = start.add(1, "days");
      } while (start.isSameOrBefore(end));
      return arr;
    },
  },
};
</script>

<style lang="scss" scoped></style>
